import React from 'react';
import { Container } from '@mui/material';

const PageContainer = ({ children, sx }) => (
  <Container
    maxWidth={false}
    disableGutters
    sx={{
      width: '100% !important',
      ml: '0 !important',
      mr: '0 !important',
      px: { xs: 2, md: 4 },
      py: { xs: 2, md: 3 },
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      ...sx,
    }}
    data-layout="page-container"
  >
    {children}
  </Container>
);

export default PageContainer;
